// Drop-down menu on hover WORKING

$('header.header').hover(function(){
  
  $('ul.list-menu li').hover(function(){
    console.log('Hovering');
    window.clearTimeout();
    
    // Clear sibling menus
    $(this).siblings().children('header-menu').children('details').prop('open', false);
    $(this).siblings().children('header-menu').children('details').children('summary').attr('aria-expanded', false);
    $(this).siblings().removeClass('active-hover');
   
    // Make this menu active
    $(this).addClass('active-hover');
    $(this).children('header-menu').children('details').prop('open', true);
    $(this).children('header-menu').children('details').children('summary').attr('aria-expanded', true);
    item = $(this);
  })
},
function(){
    console.log('No longer hovering');
  	
    $('header.menu details').prop('open', false);
    $('header.menu details summary').attr('aria-expanded', false);
  
  	window.setTimeout(function(){
        $(item).children('header-menu').children('details').prop('open', false);
        $(item).children('header-menu').children('details').children('summary').attr('aria-expanded', false);
        $(item).removeClass('active-hover');
    }, 100);
});

// End drop-down menu on hover


// Drop-down menu on hover TEST
/*
$('header.header').hover(function(){
  
  $('ul.list-menu li').hover(function(){
    console.log('Hovering');
    window.clearTimeout();
    
    // Clear sibling menus
    $(this).siblings().children('header-menu').children('.mega-menu').prop('open', false);
    $(this).siblings().children('header-menu').children('.mega-menu').children('summary').attr('aria-expanded', false);
    $(this).siblings().removeClass('active-hover');
    $(this).siblings().children('header-menu').children('.mega-menu').children('.mega-menu__content').removeClass('visible');
   
    // Make this menu active
    $(this).addClass('active-hover');
    $(this).children('header-menu').find('.mega-menu').prop('open', true);
    $(this).children('header-menu').children('.mega-menu').children('summary').attr('aria-expanded', true);
    // $(this).children('header-menu').children('.mega-menu').children('.mega-menu__content').addClass('visible');
    item = $(this);
  })
},
function(){
    console.log('No longer hovering');
  	
    $('header.menu .mega-menu').prop('open', false);
    $('header.menu .mega-menu summary').attr('aria-expanded', false);
  
  	window.setTimeout(function(){
        $(item).children('header-menu').children('.mega-menu').prop('open', false);
        $(item).children('header-menu').children('.mega-menu').children('summary').attr('aria-expanded', false);
        $(item).removeClass('active-hover');
        // $(item).children('header-menu').children('.mega-menu').children('.mega-menu__content').removeClass('visible');
    }, 100);
});
*/
// End drop-down menu on hover

// Menu items with sub-menus still redirect to initial href
$('a.header__menu-item').bind('click', function(){
  console.log('Menu item clicked');
  var href = $(this).prop('href');
  $(location).prop('href', href);
});


// Add class to Nav when scrolled passed it's own height
$(document).scroll(function(){
  
  scrollDistance = $(document).scrollTop();
  nav = $('sticky-header');
  navHeight = nav.height();
  
  if (scrollDistance > navHeight){
    nav.addClass('scroll');
  }else{
    nav.removeClass('scroll');
  };
});
// End nav scroll class